import * as types from './constants';

export function getRule({ getRuleApi, query }) {
  return {
    type: types.GET_RULE_REQUEST,
    getRuleApi,
    query,
  };
}

export function updateLikeResult({ updateLikeResultApi, requestId }) {
  return {
    type: types.UPDATE_LIKE_ANSWER_REQUEST,
    updateLikeResultApi,
    requestId
  };
}

export function updateDislikeResult({ updateDislikeResultApi, feedback, requestId }) {
  return {
    type: types.UPDATE_DISLIKE_ANSWER_REQUEST,
    updateDislikeResultApi,
    feedback,
    requestId,
  };
}

export function resetRule() {
  return {
    type: types.RESET_RULE,
  };
}